module.exports = __webpack_public_path__ + "img/favicon.c7266a06.webp";